const columnFormatterMapping = [];

export const getNameFormatterFromColumn = (sql, column, data = []) => {
  let nameFormatter = '';
  const combinedColumnDormatterMapping = [...data, ...columnFormatterMapping];
  combinedColumnDormatterMapping.forEach((map) => {
    if (sql.includes(map.id)) {
      map.mapping.forEach((ele) => {
        if (ele.column === column) nameFormatter = ele.columnNameFormatter;
      });
    }
  });
  return nameFormatter;
};

export const getValueFormatterFromColumn = (sql, column, data = []) => {
  let valueFormatter = '';
  const combinedColumnDormatterMapping = [...data, ...columnFormatterMapping];
  combinedColumnDormatterMapping.forEach((map) => {
    if (sql.includes(map.id)) {
      map.mapping.forEach((ele) => {
        if (ele.column === column) valueFormatter = ele.columnValueFormatter;
      });
    }
  });
  return valueFormatter;
};

export const getFormattedValue = (value) => {
  if (typeof value === 'string') return value;
  const numValue = value;
  if (typeof numValue !== 'number' || isNaN(numValue) || !isFinite(numValue)) {
    return value;
  }
  // TODO: // Scientific notation check
  // if (Math.abs(numValue) >= 1e7 || Math.abs(numValue) < 1e-4) {
  //   return numValue.toExponential(1);
  // }
  // Check if the number is an integer
  if (Number.isInteger(numValue)) {
    return numValue > 10000 ? numValue.toLocaleString() : numValue;
  }
  // Round decimals to 2 places
  const roundedValue = numValue.toFixed(2);
  // Add commas for numbers greater than 9999
  if (Math.abs(numValue) >= 10000) {
    return Number(roundedValue).toLocaleString();
  }
  return roundedValue;
};
